export const styles = () => ({
  checkboxWrapper: {
    alignItems: "center",
    display: "flex",
  },
});



// WEBPACK FOOTER //
// ./src/pages/director/SurveyDataCenter/components/SportCheckboxes/styles.ts